package com.milta.feature.route.data.remote.dto

import com.milta.feature.route.domain.entity.Delivery
import com.milta.feature.route.domain.entity.DeliveryStatus
import com.milta.feature.route.domain.entity.GeocodeStatus
import kotlinx.serialization.Serializable

/** Mirrors backend `DeliverySummaryDto` (MIL-38 — one entry of `RouteDetailDto.deliveries`).
 * `geocodeStatus` added by MIL-45. */
@Serializable
data class DeliveryDto(
    val id: String,
    val sortOrder: Int,
    val recipientName: String,
    val address: String,
    val status: String,
    val geocodeStatus: String,
)

fun DeliveryDto.toDomain() = Delivery(
    id = id,
    sortOrder = sortOrder,
    recipientName = recipientName,
    address = address,
    status = when (status) {
        "Completed"  -> DeliveryStatus.Completed
        "Failed"     -> DeliveryStatus.Failed
        "Untreated"  -> DeliveryStatus.Untreated
        else         -> DeliveryStatus.Pending
    },
    geocodeStatus = when (geocodeStatus) {
        "Geocoded" -> GeocodeStatus.Geocoded
        "Failed"   -> GeocodeStatus.Failed
        "Degraded" -> GeocodeStatus.Degraded
        else       -> GeocodeStatus.Pending
    },
)
